module.exports = __webpack_public_path__ + "img/logo_fe.53393870.webp";